import { cssClasses } from 'pkg/css/utils';

import MaterialSymbol from 'components/material-symbols';

import * as css from './styles.css';

interface CloseButtonProps {
	className?: string;

	onClick: () => void;
}

export default function CloseButton({ className, onClick }: CloseButtonProps) {
	return (
		<div
			onClick={onClick}
			className={cssClasses(className, css.button)}
			data-testid="close_button">
			<MaterialSymbol variant="close" />
		</div>
	);
}
